import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

import HeaderNav from "../../HeaderFotter/Header/Header.js";
import Fotter from "../../HeaderFotter/Fotter/Fotter.js";
import BlurryCursor from "../../Dependence/Cursor/cursor.jsx";
import FixedNav from "../../HeaderFotter/FixedNav/Fixednav.js";
import axiosInstance from "../../../axiosInstance.js";
import { ColorRing } from "react-loader-spinner";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Document, Page } from "react-pdf";

import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc =
  process.env.PUBLIC_URL + "/pdf.worker.min.js";
const sizes = {
  desktop: 1024,
  tablet: 768,
  phone: 576,
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] / 16}em) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.5;
  font-size: 20px;
  font-weight: 300;
  color: #111;
`;

const Section = styled.section`
  padding: 0 50px;
  padding-bottom: 100px;
  max-width: 1330px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  /* Đảm bảo padding không thay đổi kích thước của div */
  box-sizing: border-box;

  ${media.desktop`
    padding: 50px 30px; // ví dụ thay đổi padding trên desktop nhỏ
  `}
  ${media.tablet`
    padding: 20px 20px; // thay đổi padding trên tablet
  `}
  ${media.phone`
    padding: 10px 10px; // thay đổi padding trên điện thoại
    padding-bottom: 100px; // giảm padding bottom trên điện thoại
  `}
`;

const IdeaTest = ({ token }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [users, setUsers] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const fetchProtectedData = async () => {
      try {
        const response = await axiosInstance.get("/auth/protected", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(response.data.user);
        setMessage(response.data.message);
      } catch (error) {
        setMessage("You are not authorized to view this page");
        localStorage.removeItem("token");
        navigate("/login");
        // window.location.href = '/login'; // Redirect to login page
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      fetchProtectedData();
    }
  }, [token]);

  const [numPages, setNumPages] = useState();
  // const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  return (
    <Container className="content">
      {/* headder */}
      <HeaderNav/>

      {/* Section 1 */}
      <Section
        className="our-teams opacity-1 bg-mask"
        // style={{ paddingTop: "100px" }}
      >
        <p className="text-center uppercase font-bold text-clamp-50">
          Idea Test
        </p>
        <div className="pdf-div">
          <Document
            file="/Img/Challenge/Testidea.pdf"
            onLoadSuccess={onDocumentLoadSuccess}
            style={{ width: "100%" }}
          >
            {Array.apply(null, Array(numPages))
              .map((x, i) => i + 1)
              .map((page) => {
                return (
                  <Page
                    pageNumber={page}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                );
              })}
          </Document>
        </div>
      </Section>

      <Fotter></Fotter>

      <FixedNav />
      <BlurryCursor />

      {/* <ToastContainer /> */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(75 81 99 / 80%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <ColorRing
            height={70}
            width={70}
            color="#4fa94d"
            ariaLabel="loading-indicator"
          />
        </div>
      )}
    </Container>
  );
};

export default IdeaTest;
